import { toast } from 'react-toastify';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import SideBar from "../commanComponents/sidebar/sidebar";

import "./editProfile.css";
import { sidebarNavItems, genderList, ROUTES } from "../../constant";
import { getCountryService, getStateService, getCityService, editProfileService, getStudentProfileService } from '../../modules/services';
import InputDropdown from '../commanComponents/dropdown/dropdown';
import TopNavigation from "../commanComponents/topNavigation/topNavigation";
import InputField from '../commanComponents/inputField/inputField';
import { validateName, validateDate, validatePhone, validatePincode, validateLastName } from '../../utils/validations';
import PrimaryButton from '../commanComponents/primaryButton/primaryButton';
import { loadData, saveJsonData, clearData } from '../../utils/localStorage';


const EditProfile = (props) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [firstClick, setFirstClick] = useState(false);
    const [countryData, setCountryData] = useState([]);
    const [stateData, setstateData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [firstNameInvalid, setFirstNameInvalid] = useState({ isError: false, errorMessage: "" });
    const [lastNameInvalid, setLastNameInvalid] = useState({ isError: false, errorMessage: "" });
    const [dobInvalid, setDobInvalid] = useState({ isError: false, errorMessage: "" });
    const [genderInvalid, setGenderInvalid] = useState({ isError: false, errorMessage: "" });
    const [phoneNoInvalid, setPhoneNoInvalid] = useState({ isError: false, errorMessage: "" });
    const [cityInvalid, setCityInvalid] = useState({ isError: false, errorMessage: "" });
    const [stateInvalid, setStateInvalid] = useState({ isError: false, errorMessage: "" });
    const [countryInvalid, setCountryInvalid] = useState({ isError: false, errorMessage: "" });
    const [pincodeInvalid, setPincodeInvalid] = useState({isError: false, errorMessage: "" });
    const [data, setData] = useState({
        first_name: "",
        last_name: "",
        dob: "",
        gender: "",
        phone: "",
        city: "",
        state: "",
        country: "",
        pincode: ""
    });

    const getCityDataService = useCallback((state) => {
        (async () => {
            const responseData = await getCityService({state: state});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setCityData(renderDropdownListData(responseData.data, true));
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }, []);

    const getStateDataService = useCallback((country, resData) => {
        (async () => {
            const responseData = await getStateService({country_id: country});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                const stateList = renderDropdownListData(responseData.data);
                setstateData(stateList);

                if (resData && resData.state) {
                    const activeState = stateList.filter(option => option.value === resData.state)[0]
                    if (activeState) {
                        getCityDataService(activeState.id);
                    }
                }
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }, [getCityDataService]);

    const getCountryDataService = useCallback((resData) => {
        (async () => {
            const responseData = await getCountryService({});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                const countryList = renderDropdownListData(responseData.data);
                setCountryData(countryList);
                if (resData.country) {
                    getStateDataService(countryList.filter(option => option.value === resData.country)[0].id, resData);
                }
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }, [getStateDataService]);


    useEffect(() => {
        (async () => {
            const responseData = await getStudentProfileService({});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                const gender = responseData.data.gender?.toUpperCase();
                responseData.data.gender = gender ? typeof gender !== "undefined" : "";
                setData(responseData.data);
                getCountryDataService(responseData.data);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
        
    }, [getCountryDataService]);

    const renderDropdownListData = (listData, isCity=null) => {
        if (isCity) {
            return (listData.map(data =>({label:data.city,value:data.city, id: data.id})))
        }
        return (listData.map(data =>({label:data.name,value:data.name, id: data.id})))
    }

    const onDOBFocus = (e) => (e.target.type = "date");
    const onDOBBlur = (e) => (e.target.type = "text");
    
    const handleFirstNameChange = (firstName) => {
        setData({ ...data, first_name: firstName });
        var errorMessage = validateName(firstName);
        var isError;
        if (errorMessage === "") {
            setFirstNameInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setFirstNameInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }
        setFirstClick(true);
        return isError;
    }

    const handleLastNameChange = (lastName) => {
        setData({ ...data, last_name: lastName });
        var errorMessage = validateLastName(lastName);
        var isError;
        if (errorMessage === "") {
            setLastNameInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setLastNameInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }
        setFirstClick(true);
        return isError;
    }
    
    const handleDobChange = (dob) => {
        setData({ ...data, dob: dob });
        var errorMessage = validateDate(dob);
        var isError;
        if (errorMessage === "") {
            setDobInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setDobInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }
        setFirstClick(true);
        return isError;
     }
    const handleGenderChange = (gender) => {
        setData({ ...data, gender: gender.value });
        var errorMessage = validateDate(gender.value);
        var isError;
        if (errorMessage === "") {
            setGenderInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setGenderInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }
        setFirstClick(true);
        return isError;
     }
    const handlePhoneChange = (phone) => {
        setData({ ...data, phone: phone });
        var errorMessage = validatePhone(phone);
        var isError;
        if (errorMessage === "") {
            setPhoneNoInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setPhoneNoInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }
        setFirstClick(true);
        return isError;
     }
    const handleCityChange = (city) => {
        setData({ ...data, city: city.value });
        var errorMessage = validateDate(city.value);
        var isError;
        if (errorMessage === "") {
            setCityInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setCityInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }
        setFirstClick(true);
        return isError;
     }
    const handleStateChange = (state) => { 
        setData({ ...data, state: state.value });
        var errorMessage = validateDate(state.value);
        var isError;
        if (errorMessage === "") {
            setStateInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setStateInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }

        if (state.value !== data.state) {
            const activeState = stateData.filter(option => option.value === state.value)[0];
            if (activeState) {
                getCityDataService(activeState.id);
            }
        }

        setFirstClick(true);
        return isError;
    }
    const handleCountryChange = (country) => {
        setData({ ...data, country: country.value });
        var errorMessage = validateDate(country.value);
        var isError;
        if (errorMessage === "") {
            setCountryInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setCountryInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }

        if (country.value !== data.country) {
            getStateDataService(countryData.filter(option => option.value === country.value)[0].id);
        }
        setFirstClick(true);
        return isError;
     }
    const handlePincodeChange = (pincode) => { 
        setData({ ...data, pincode: pincode });
        var errorMessage = validatePincode(pincode);
        var isError;
        if (errorMessage === "") {
            setPincodeInvalid({ isError: false, errorMessage: "" });
            isError = false;
        }
        else {
            setPincodeInvalid({ isError: true, errorMessage: errorMessage });
            isError = true;
        }
        setFirstClick(true);
        return isError;
    }

    const handleChangePasswordSave = () => { 
        const isFirstError = handleFirstNameChange(data.first_name);
        const isLastError = handleLastNameChange(data.last_name);
        const isDobError = handleDobChange(data.dob);
        const isGenderError = handleGenderChange({ value: data.gender });
        const isPhoneError = handlePhoneChange(data.phone);
        const isCountryError = handleCountryChange({ value: data.country });
        const isStateError = handleStateChange({ value: data.state });
        const isCityError = handleCityChange({ value: data.city });
        const isPincodeError = handlePincodeChange(data.pincode);

        if (!isFirstError && !isLastError && !isDobError && !isGenderError && !isPhoneError
            && !isCountryError && !isStateError && !isCityError && !isPincodeError && firstClick) { 
            setIsLoading(true);
            (async () => {
                const responseData = await editProfileService(data.id, data, {});
                if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                    setIsLoading(false);
                        var userData = loadData("user");
                        userData = JSON.parse(userData);
                        userData.first_name = data.first_name;
                        userData.last_name = data.last_name;
                        saveJsonData("user", userData);
                        navigate(ROUTES.PROFILE);
                }
                else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                    resetFields();
                }
                else {
                    clearData();
                    navigate(ROUTES.LOGIN);
                }
            })();
        }
    }

    const resetFields = () => {
        setIsLoading(false);
        setData({
            first_name: "",
            last_name: "",
            dob: "",
            gender: "",
            phone: "",
            city: "",
            state: "",
            country: "",
            pincode: ""
        });
    }

    return (
        <div className='edit-profile-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.profile} />
            <div className='edit-profile-side-container'>
                <TopNavigation activeItem={sidebarNavItems.profile} />
                
                <div className='row edit-profile-filter-container'>
                </div>
                
                <div className='edit-profile-main-container'>
                    <div className='row'>
                        <div className='col'>
                        <h5>Edit Profile</h5>
                        </div>
                        <div className='col edit-profile-header-right'>
                            <PrimaryButton
                                onClick={() => handleChangePasswordSave()}
                                isLoading={isLoading}
                                text="SAVE"
                            />
                        </div>
                    </div>
                    
                    <hr className="edit-profile-border" />
                    <div className='row edit-profile-input-row'>
                        <div className='col-sm'>
                            <InputField
                                iconClass="bi-person-fill"
                                placeholder="First name"
                                fieldType="text"
                                isInvalid={firstNameInvalid.isError}
                                onChange={handleFirstNameChange}
                                errorMessage={firstNameInvalid.errorMessage}
                                value={data.first_name}
                                inputKey="first_name_key"
                                maxWidth="400px"
                            />
                        </div>
                        <div className='col-sm'>
                            <InputField
                                iconClass="bi-person-fill"
                                placeholder="Last Name"
                                fieldType="text"
                                isInvalid={lastNameInvalid.isError}
                                onChange={handleLastNameChange}
                                errorMessage={lastNameInvalid.errorMessage}
                                value={data.last_name}
                                inputKey="last_name_key"
                                maxWidth="400px"
                            />
                        </div>
                    </div>
                    <div className='row edit-profile-input-row'>
                        <div className='col-sm'>
                            <InputField
                                iconClass="bi-calendar-fill"
                                iconSize="15px"
                                placeholder="Date of Birth"
                                fieldType="text"
                                isInvalid={dobInvalid.isError}
                                onChange={handleDobChange}
                                errorMessage={dobInvalid.errorMessage}
                                value={data.dob}
                                inputKey="date_of_birth_key"
                                maxWidth="400px"
                                onFocus={onDOBFocus}
                                onBlur={onDOBBlur}
                            />
                        </div>
                        <div className='col-sm'>
                            <InputDropdown
                                inputKey="gender_key"
                                iconClass="bi-person-circle"
                                itemList={genderList}
                                maxWidth="400px"
                                placeholder="Gender"
                                defaultValue={genderList.filter(option => option.value === data.gender)[0]}
                                onChange={handleGenderChange}
                                isInvalid={genderInvalid.isError}
                                errorMessage={genderInvalid.errorMessage}
                            />
                        </div>
                    </div>
                    <div className='row edit-profile-input-row'>
                        <div className='col-sm'>
                            <InputField
                                iconClass="bi-telephone-fill"
                                iconSize="15px"
                                placeholder="phone number"
                                fieldType="text"
                                isInvalid={phoneNoInvalid.isError}
                                onChange={handlePhoneChange}
                                errorMessage={phoneNoInvalid.errorMessage}
                                value={data.phone}
                                inputKey="phone_number_key"
                                maxWidth="400px"
                            />
                        </div>
                        <div className='col-sm'>
                            <InputDropdown
                                inputKey="country_key"
                                iconClass="bi-geo-alt-fill"
                                itemList={countryData}
                                maxWidth="400px"
                                placeholder="Country"
                                onChange={handleCountryChange}
                                defaultValue={countryData.filter(option => option.value === data.country)[0]}
                                isInvalid={countryInvalid.isError}
                                errorMessage={countryInvalid.errorMessage}
                            />
                        </div>
                    </div>
                    <div className='row edit-profile-input-row'>
                        <div className='col-sm'>
                            <InputDropdown
                                inputKey="state_key"
                                iconClass="bi-geo-alt-fill"
                                itemList={stateData}
                                maxWidth="400px"
                                placeholder="State"
                                onChange={handleStateChange}
                                defaultValue={stateData.filter(option => option.value === data.state)[0]}
                                isInvalid={stateInvalid.isError}
                                errorMessage={stateInvalid.errorMessage}
                                isDisabled={
                                    data.country ?
                                        false
                                        :
                                        true
                                }
                            />
                        </div>
                        <div className='col-sm'>
                            <InputDropdown
                                inputKey="city_key"
                                iconClass="bi-geo-alt-fill"
                                itemList={cityData}
                                maxWidth="400px"
                                placeholder="City"
                                onChange={handleCityChange}
                                defaultValue={cityData.filter(option => option.value === data.city)[0]}
                                isInvalid={cityInvalid.isError}
                                errorMessage={cityInvalid.errorMessage}
                                isDisabled={
                                    data.state ?
                                        false
                                        :
                                        true
                                }
                            />
                        </div>
                    </div>
                    <div className='row edit-profile-input-row'>
                        <div className='col-sm'>
                            <InputField
                                iconClass="bi-pin-map-fill"
                                iconSize="15px"
                                placeholder="Pincode"
                                fieldType="text"
                                isInvalid={pincodeInvalid.isError}
                                onChange={handlePincodeChange}
                                errorMessage={pincodeInvalid.errorMessage}
                                value={data.pincode}
                                inputKey="pincode_key"
                                maxWidth="400px"
                            />
                        </div>
                        <div className='col-sm'>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
 }


export default EditProfile;
